import { useFindOneContactSentimentByChatIdQuery } from 'services';
import { FindOneContactSentimentByChatDto } from 'types';

export const useFindOneContactSentimentByChat = (data?: FindOneContactSentimentByChatDto, options?: any) => {
  const {
    data: contactSentiment,
    isLoading: isLoadingContactSentiment,
    isFetching: isFetchingContactSentiment,
    refetch: refetchContactSentiment
  } = useFindOneContactSentimentByChatIdQuery(data!, {
    refetchOnMountOrArgChange: true,
    skip: !data,
    ...options
  });

  return {
    contactSentiment: contactSentiment?.data,
    isLoadingContactSentiment,
    isFetchingContactSentiment,
    refetchContactSentiment
  };
};
